import React, { FormEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { useForm } from '@inertiajs/react'
import { AppLayout } from '@/components/layouts/AppLayout'

interface ChannelData {
  id: number
  name: string
  slug: string
  description: string | null
  visibility: string
  channel_type: string
}

interface Props {
  channel: ChannelData
}

export default function Edit({ channel }: Props) {
  const isDm = channel.channel_type === 'dm'

  const { data, setData, put, processing } = useForm({
    channel: {
      name: channel.name,
      description: channel.description || '',
      visibility: channel.visibility,
    }
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put(`/messages/channels/${channel.slug}`)
  }

  return (
    <AppLayout title={`Edit: ${channel.name}`}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          maxWidth: 600,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Channel name"
            fullWidth
            autoFocus
            value={data.channel.name}
            onChange={e => setData('channel', { ...data.channel, name: e.target.value })}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Description (optional)"
            fullWidth
            multiline
            rows={3}
            value={data.channel.description}
            onChange={e => setData('channel', { ...data.channel, description: e.target.value })}
            sx={{ mb: 3 }}
          />

          {!isDm && (
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>Visibility</InputLabel>
              <Select
                value={data.channel.visibility}
                label="Visibility"
                onChange={e => setData('channel', { ...data.channel, visibility: e.target.value })}
              >
                <MenuItem value="public">Public - Anyone can see and join</MenuItem>
                <MenuItem value="protected">Protected - Anyone can see, must request to join</MenuItem>
                <MenuItem value="private">Private - Only members can see</MenuItem>
              </Select>
            </FormControl>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={processing || !data.channel.name.trim()}
          >
            Update channel
          </Button>
        </Box>
      </Paper>
    </AppLayout>
  )
}
